import { RouteConfig } from 'vue-router'

const router: RouteConfig[] = [
  {
    path: '/dashboard',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', component: () => import('pages/Dashboard/Index.vue') }
    ],
    meta: { requiresAuth: true }
  }
]

export default router
